export function PipedriveAccountDetail() {
    return <div className="p-5">
        Coming soon...
    </div>
}